import { Link } from "react-router-dom";

// Transparent-background logo (white removed), served from /public.
export const LOGO_URL = "/logo.png";

// Header lockup — actual logo, transparent background, enlarged.
export const Logo = () => (
  <Link to="/home" data-testid="logo-home-link" className="flex items-center group">
    <img
      src={LOGO_URL}
      alt="Choices & Decisions"
      className="h-16 md:h-20 w-auto object-contain transition-transform duration-500 group-hover:scale-[1.04]"
    />
  </Link>
);

// Footer / dark-background version — logo on a soft cream chip so the purple wordmark stays legible.
export const LogoBadge = ({ className = "" }) => (
  <span className={`inline-flex items-center rounded-2xl bg-cream px-5 py-3 ${className}`}>
    <img src={LOGO_URL} alt="Choices & Decisions" className="h-12 md:h-14 w-auto object-contain" />
  </span>
);
